import {Component, Output, Input, EventEmitter} from '@angular/core';
import {StudiosService} from './../../services/studios';
import {MapService} from './../../services/map'
import {SessionService} from '../../services/session';
import {BackendModule} from '../../modules/backend.module';
import {BeautyStudiosService} from '../../services/beauty-studios';
import {BeautyMapService} from '../../services/beauty-map';

declare var mapboxgl: any;

@Component({
  selector: 'app-mapbox-map',
  templateUrl: './mapbox-map.component.html',
})
export class MapboxMapComponent {
  @Output() studioSelected = new EventEmitter();
  @Input() selectStudio: any;
  @Input() product: string;

  constructor(
    public fitnessStudiosService: StudiosService,
    public beautyStudiosService: BeautyStudiosService,
    private backendModule: BackendModule,
    public fitnessMapService: MapService,
    public beautyMapService: BeautyMapService,
    public sessionService: SessionService
  ) {
  }

  map: any;
  myMarker: any;
  gymMarkers = {};
  gymIdSelected: number;
  gyms = [];

  ngOnInit() {
    console.log('MapboxMapComponent -> ngOnInit -> this.product', this.product);

    this.gyms = (this.product === 'beauty') ? this.beautyStudiosService.studios : this.fitnessStudiosService.studios;

    this.initMap(this.mapService.myLocation);
    this.addMarkers();
    if (!this.mapService.lastSelectedMarker) {
      this.addMyLocation();
    }
  }

  //Makes a google map
  initMap(center) {
    mapboxgl.accessToken = this.backendModule.mapBoxToken;

    this.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v12', // style URL
      center: [center.lng, center.lat],
      zoom: 13,
    });
  }

  get mapService() {
    return this.product === 'beauty' ? this.beautyMapService : this.fitnessMapService;
  }

  getIcon(pro) {
    if (this.product === 'beauty') {
      return 'url(./assets/img/map/beauty_non_selected.png)';
    }

    return pro ?
      'url(./assets/img/map/non_selected_pro.png)' :
      'url(./assets/img/map/non_selected.png)';
  }

  //adds all found markers
  addMarkers() {
    const features = this.gyms.map((studioInfo: any) => {
      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [studioInfo.longitude, studioInfo.latitude]
        },
        properties: {
          title: studioInfo.name,
          description: studioInfo.address,
          id: studioInfo.id,
          pro: studioInfo.pro
        }
      }
    });

    const geojson = {
      type: 'FeatureCollection',
      features: features
    }


    // add markers to map
    for (const feature of geojson.features) {

      // code from step 5-1 will go here
      const el = document.createElement('div');
      el.className = 'marker';
      el.dataset.id = feature.properties.id;

      el.style.backgroundImage = this.getIcon(feature.properties.pro)
      el.style.backgroundSize = 'contain';
      el.style.backgroundRepeat = 'no-repeat';
      el.style.backgroundPosition = 'center';
      // el.style.borderRadius = '50%';
      el.style.width = '22px';
      el.style.height = '26px';
      el.style.cursor = 'pointer';

      el.addEventListener('click', (event) => {
        const pin = event.target as HTMLElement;
        const id = parseInt(pin.dataset.id, 10);
        console.log('=> Selected studio', id);

        const gym = this.gyms.find(studio => studio.id === id);

        if (gym) {
          console.log('=> Selected gym', gym);
          // this.studioSelected.emit({studioInfo: gym})

          this.selectGym(gym);
        }
      });

      // make a marker for each feature and add to the map
      this.gymMarkers[feature.properties.id] =
        new mapboxgl.Marker(el)
          .setLngLat(feature.geometry.coordinates)
          .addTo(this.map);

      //code from step 6 will go here
    }
  }

  selectGym(gym) {
    this.map.flyTo({
      center: [gym.longitude, gym.latitude],
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });

    this.displaySelectedMarker(gym);
    this.emitToFatherComponent(gym);
  }

  displaySelectedMarker(gym) {

    if (this.gymIdSelected) {
      const previousMarker = this.gymMarkers[this.gymIdSelected];

      if (previousMarker) {
        const previousGym = this.gyms.find(studio => studio.id === this.gymIdSelected);
        const el = previousMarker.getElement();

        el.style.backgroundImage = this.getIcon(previousGym && previousGym.pro)
      }
    }

    this.gymIdSelected = gym.id;

    // This is important to keep track of the last selected marker
    // But it has to be named as lastSelectedGym, WHAT THE HELL
    this.mapService.lastSelectedMarker = gym;

    const marker = this.gymMarkers[gym.id];
    const el = marker.getElement();
    el.style.backgroundImage = 'url(./assets/img/map/selected.png)';
  }

  //ads a marker in my current position and pans to it
  addMyLocation() {
    if (!this.myMarker) {
      const el = document.createElement('div');
      el.className = 'marker';
      el.dataset.id = 'myLocation';

      el.style.backgroundImage = 'url(./assets/img/map/my_location.png)';
      el.style.backgroundSize = 'contain';
      el.style.backgroundRepeat = 'no-repeat';
      el.style.backgroundPosition = 'center';

      el.style.width = '22px';
      el.style.height = '26px';
      el.style.cursor = 'pointer';

      this.myMarker = new mapboxgl.Marker(el)
        .setLngLat([this.mapService.myLocation.lng, this.mapService.myLocation.lat])
        .addTo(this.map);
    }

    this.map.flyTo({
      center: [this.mapService.myLocation.lng, this.mapService.myLocation.lat],
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });
  }

  //listens if there is an input in the search bar
  ngOnChanges() {
    console.log('=> ngOnChanges', this.mapService.lastSelectedMarker);

    if (!this.mapService.lastSelectedMarker) {
      this.clearSelection();
    }
  }

  //removes the Last selected marker
  clearSelection() {
    if (!this.gymIdSelected) {
      return
    }

    const previousMarker = this.gymMarkers[this.gymIdSelected];
    const gym = this.gyms.find(studio => studio.id === this.gymIdSelected);
    const el = previousMarker.getElement();

    el.style.backgroundImage = this.getIcon(gym && gym.pro);
    this.gymIdSelected = null;
  }

  emitToFatherComponent(studioInfo) {
    setTimeout(() => {
      this.studioSelected.emit({studioInfo})
    }, 1);
  }
}



// WEBPACK FOOTER //
// ./src/components/mapbox-map/mapbox-map.component.ts